import type { ValidationResult } from '@idem/tipos/validation-result.type';
import type { ValidationOptions } from '@idem/tipos/validation-options.type';

export const validateMaxLength =
  (maxLength: number) =>
  (options: ValidationOptions & ValidationResult): ValidationResult => {
    if (options.value && options.value.length > maxLength) {
      return {
        ...options,
        code: 'too-long',
        message: fieldName => `${fieldName} no puede ser mayor a ${maxLength} caracteres.`,
      };
    }
    return options;
  };
